// ModalMessage.jsx

import React from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './ModalMessage.css';

/**
 * ModalMessage Component
 * 
 * This component renders a message for a modal item.
 * 
 * @param {string} text - The text of the message.
 * 
 * @returns {ReactNode} The rendered component.
 */
const ModalMessage = ({ text }) => {

  // ----- CONTEXT ----- //

  // Theme Context
  const { theme } = useTheme();

  // ----- RENDER ----- //

  return (
    <div className="modal-message-container"
      style={{
        color: theme.foreground,
      }}>
      {text}
    </div>
  );
};

export default ModalMessage;
